export const ADD = 'entities/deed/ADD';
export const ADD_MULTIPLE = 'entities/deed/ADD_MULTIPLE';
export const UPDATE = 'entities/deed/UPDATE';
export const UPDATE_DEED_PARTIALLY = 'entities/deed/UPDATE_DEED_PARTIALLY';
export const REMOVE = 'entities/deed/REMOVE';
export const UPCOMING_DEEDS_LOADED = 'entities/deed/UPCOMING_DEEDS_LOADED';
export const PAST_DEEDS_LOADED = 'entities/deed/PAST_DEEDS_LOADED';
